import { appEnv } from '@/app/config/env';
import { createClient } from '@/app/libs/axios/config/client';

const httpClient = createClient(appEnv.apiURL, appEnv.apiKey);
const reportsClient = createClient(appEnv.reportApiURL, appEnv.reportApiKey);

export { httpClient, reportsClient };
